import { FC, ReactNode } from "react";
import { Group, Drawer as MantineDrawer, DrawerProps as MantineDrawerProps } from "@mantine/core";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";
import styles from "./styles.module.css";

type DrawerProps = Partial<MantineDrawerProps> & {
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  children: ReactNode;
  ctaRow?: ReactNode;
};

const Drawer: FC<DrawerProps> = ({ children, isOpen, onClose, ctaRow, ...drawerProps }) => {
  return (
    <MantineDrawer
      opened={isOpen}
      onClose={onClose}
      position="right"
      size="lg"
      classNames={{
        header: styles.header,
        body: styles.body,
      }}
      {...drawerProps}
    >
      <div className={styles.content}>{children}</div>

      {ctaRow && <div className={styles.cta}>{ctaRow}</div>}
    </MantineDrawer>
  );
};

export default Drawer;

type DrawerHeaderProps = {
  title: string;
  svgName: string;
};
export const DrawerHeader = ({ title, svgName }: DrawerHeaderProps) => {
  return (
    <Group gap="20px" align="center">
      <SVGAsset name={svgName} />
      <Text size="md" display="technical" tt="uppercase" strong={true}>
        {title}
      </Text>
    </Group>
  );
};
